import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {InputNumber} from "primereact/inputnumber";
import {Button} from 'primereact/button';
import {BlockUI} from "primereact/blockui";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";
import {Dropdown} from "primereact/dropdown";

const _FM_ReceiptitemFormComponent = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {entity, action, id} = useParams();
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [folioItems, setFolioItems] = useState([]);
  const [vatPercents, setVatPercents] = useState([]);
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (window.App.urlVars().receiptItemId) {
      apiCall('patch', 'invoice-item/' + window.App.urlVars().receiptItemId, newFormData)
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({})
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderReceiptitemList: Math.random(),
            rerenderReceiptForm: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      apiCall('post', 'invoice-item', formData)
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderReceiptitemList: Math.random(),
            rerenderReceiptForm: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          } else {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  useEffect(() => {
    if (window.App.urlVars().receiptItemId) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "invoice-item/" + window.App.urlVars().receiptItemId,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
    apiCall('get', 'folio-item')
      .then(response => {
        setFolioItems(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'vat-group')
      .then(response => {
        setVatPercents(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'dictionary/service-unit')
      .then(response => {
        setUnits(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  useEffect(() => {
    if (id) {
      setFormData({
        ...formData,
        invoice: id
      })
    }
  }, [id])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('receiptitem_form')}</h2>
                </div>
                <div className={"p-col p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
              <span>
                <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
              </span>
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                {/*<div className={"p-col-12 p-lg-3"}>*/}
                {/*  <Field name="folio_item" render={({input, meta}) => (*/}
                {/*    <div className="p-field p-fluid">*/}
                {/*      <HelpComponent type={"field"} field={"folio_item"}/>*/}
                {/*      <label htmlFor="folio_item"*/}
                {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('folio_item')}</label>*/}
                {/*      <span className="p-d-block">*/}
                {/*        <Dropdown  options={folioItems}*/}
                {/*                  filter*/}
                {/*                  optionLabel="label"*/}
                {/*                  optionValue="id"*/}
                {/*                  id={"folio_item"}*/}
                {/*                  emptyMessage={t('empty_message')}*/}
                {/*                  onChange={(e) => {*/}
                {/*                    let _folio_item = folioItems.filter(item => item.id === e.value)*/}
                {/*                    setFormData({*/}
                {/*                      ...formData,*/}
                {/*                      folio_item: e.value,*/}
                {/*                      name: _folio_item[0].label,*/}
                {/*                      quantity: _folio_item[0].quantity,*/}
                {/*                      unit: _folio_item[0]?.service?.unit,*/}
                {/*                      unit_net_amount: _folio_item[0]?.service?.net_amount,*/}
                {/*                      vat_percent: _folio_item[0]?.service?.vat_group?.vat_percent,*/}
                {/*                    })*/}
                {/*                    setNewFormData({*/}
                {/*                      ...newFormData,*/}
                {/*                      folio_item: e.value,*/}
                {/*                      name: _folio_item[0].label,*/}
                {/*                      quantity: _folio_item[0].quantity,*/}
                {/*                      unit: _folio_item[0]?.service?.unit,*/}
                {/*                      unit_net_amount: _folio_item[0]?.service?.net_amount,*/}
                {/*                      vat_percent: _folio_item[0]?.service?.vat_group?.vat_percent,*/}
                {/*                    })*/}
                {/*                  }}*/}
                {/*                  value={formData.folio_item}*/}
                {/*        />*/}
                {/*    </span>*/}
                {/*      {getFormErrorMessage(meta)}*/}
                {/*    </div>*/}
                {/*  )}/>*/}
                {/*</div>*/}
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"name"}/>
                      <label htmlFor="Receiptitem_code"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                      <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-1"}>
                  <Field name="quantity" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"quantity"}/>
                      <label htmlFor="quantity"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('quantity')}</label>
                      <span className="p-d-block">
                      <InputText id="quantity" {...input}
                                 keyfilter={"num"}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     quantity: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     quantity: e.target.value
                                   })
                                 }}
                                 value={formData.quantity}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-2"}>
                  <Field name="unit" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"unit"}/>
                      <label htmlFor="unit"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('unit')}</label>
                      <span className="p-d-block">
                        <Dropdown  options={units}
                                  filter
                                  optionLabel="value"
                                  optionValue="value"
                                  id={"unit"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      unit: e.value,
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      unit: e.value,
                                    })
                                  }}
                                  value={formData.unit}
                        />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-2"}>
                  <Field name="unit_net_amount" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"unit_net_amount"}/>
                      <label htmlFor="unit_net_amount"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('net_amount')}</label>
                      <span className="p-d-block">
                      <InputText id="unit_net_amount" {...input}
                                 keyfilter={"num"}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     unit_net_amount: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     unit_net_amount: e.target.value
                                   })
                                 }}
                                 value={formData.unit_net_amount}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-1"}>
                  <Field name="vat_percent" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"vat_percent"}/>
                      <label htmlFor="vat_percent"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('vat_percent')}</label>
                      <span className="p-d-block">
                        <Dropdown  options={vatPercents}
                                  filter
                                  optionLabel="vat_percent"
                                  optionValue="vat_percent"
                                  id={"vat_percent"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      vat_percent: e.value,
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      vat_percent: e.value,
                                    })
                                  }}
                                  value={formData.vat_percent}
                        />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
            </Panel>
          </form>
        )}/>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_ReceiptitemFormComponent);
